export default __webpack_public_path__ + "static/Bootcamp-1-b5ae18b4ce9f6a88c5783e45ee604c3e.jpg";